<template>
  <div>
    <v-head></v-head>
    <div class="more_bg">
      <img src="../assets/pic02.png" alt="">
      <div class="more_txt">
        <div class="title">
           智能AI
        </div>
        <div class="txt">
          Intelligent AI
        </div>
      </div>
    </div>
    <div class="more_content">
      <div class="more_left">
        <img src="../assets/pic71.png" alt="">
      </div>
      <div class="more_right">
        <div class="maxTitle">应用人脸识别和激光引导技术的五防安全辅助装置</div>
        <div class="more_wrap">
          <div class="title">产品介绍</div>
          <div class="txt">
            本产品针对变电站运行维护的过程中，五防锁管理效率低下、安全系数低、开锁时间长、开锁不准确等实际操作问题，将人脸识别智能技术手段引入五防锁的智能解锁控制系统。<br>
基于人脸识别和激光引导技术的五防安全辅助装置是一种变电站五防锁的智能解锁控制系统，支持基于人脸识别一键解锁的工作人员身份验证功能。通过对操作人员人脸识别，对五防锁的智能解锁控制系统提供人员的信息确认，提高五防钥匙的安全性。
本产品所提出的方案显著改善了五防锁管理效率，具备市场推广价值，对促进变电站安全稳定运行，提高供电可靠性具有重要意义，其应用前景广阔。
          </div>
          <div class="title">相关案例</div>
          <img src='../assets/pic72.png' alt="" @click="gotoDetail">
          <div class="txt last">应用人脸识别和激光引导技术的五防安全辅助装置</div>
        </div>
      </div>
    </div>
    <div class="more_detail">
      <div class="title_wrap">
        <div class="title">
          产品详情
        </div>
        <div class="mini_title">
          DETAILS
        </div>
      </div>
      <div class="box">
        <div class="more_top">
          <div class="more_list begin">
            <div class="title">人脸识别算法设计</div>
            <div class="en">Face recognition algorithm design</div>
            <div class="txt"><span class="el-icon-caret-right"></span>设计基于特征分析的人脸识别算法，深入地从硬件
和软件两个方面研究了变电站五防安全控制系统，
提供了一种基于人脸识别的五防安全辅助装置方案</div>
            
          </div> 
          <div class="more_list begin">
            <div class="title">人脸识别软件设计</div>
            <div class="en">Face recognition software design</div>
            <div class="txt"><span class="el-icon-caret-right"></span>设计了人脸识别五防装置软件，包括网络通信模块、
解锁控制模块、可见光图像采集模块、人脸识别处
理模块。同时设计了一套完整的五防钥匙箱解锁流
程，具有非常标准、安全稳定可靠的特点，能够应
用到实际的变电站设施中，为五防安全提供了一种
可行有效的方案。</div>
          </div>
          
          <div class="more_list bottom begin">
            <div class="title">通信网络	</div>
            <div class="en">Communication Network</div>
            <div class="txt"><span class="el-icon-caret-right"></span>采用高性能无线路由器组建无线局域网，控制终端通
过无线通讯方式控制所有在线设备，无线高清摄像头
实时画面分辨率可达2560x1440。</div>
          </div>
          
        </div>
        <div class="more_top">
          <div class="more_list">
            <div class="title">图像识别</div>
            <div class="en">Image Recognition</div>
            <div class="txt"><span class="el-icon-caret-right"></span>可识别多种类型开关柜上的开关按钮，指针仪表，
旋钮，面板指示灯及数字，并存入本地数据库中。</div>
            
          </div> 
          <div class="more_list">
            <div class="title">文字识别</div>
            <div class="en">Text Recognition</div>
            <div class="txt"><span class="el-icon-caret-right"></span>基于tesseract开发了一种操作票文字识算法，可
实现操作票文字内容的准确提取和语义逻辑判断，
快速将操作票的文字内容转换成计算机控制指令。</div>
          </div>
          
          <div class="more_list bottom">
            <div class="title">混合定位</div>
            <div class="en">Hybrid positioning</div>
            <div class="txt"><span class="el-icon-caret-right"></span>基于WIFI和RFID的变电站机器人室内混合定位方法，
能够实现对变电站机器人的室内位置定位，提高机
器人室内定位精度，保证机器人的运动安全性和操
作准确性。</div>
          </div>
          
        </div>
        <div class="more_top end">
          <div class="more_list">
            <div class="title">安全保障</div>
            <div class="en">Safety and security</div>
            <div class="txt"><span class="el-icon-caret-right"></span>1）智能防撞，遇到障碍自动停止，防止碰撞造成
人员及设备损伤；
2）安全定点充电功能（接触式防打火安全分布式
充电站配合蓄电池）；
3）控制终端对巡检数据及传感器采集数据进行实
时监视，对异常数据进行分级报警；
4）通过采集实时声音数据，对异常声音进行判断
识别并报警。</div>
          </div> 
          <div class="more_list">
            <div class="title">特色功能</div>
            <div class="en">Featured Features</div>
            <div class="txt"><span class="el-icon-caret-right"></span>1）手动/自动控制模式灵活切换，工作人员可打断
机器人自动巡检模式，远程手动控制巡视，退出手
动模式后，机器人自动复位，继续巡检工作；
2）携带众多必要传感器：氧气含量传感器、环境
温度传感器、湿度传感器、烟雾传感器、有害气体
含量传感器等，实时监测变电站环境状况；
3）配备多个红外成像模块，可以实时监测中部及
两侧设备温度状况，温度异常情况下进行分级报警，
并可结合高清摄像头进行故障定位及诊断；
4）配备本地独立数据库进行数据的存储及读取，
控制终端预留对电站内网接口，实现巡检数据的共
享；
5）控制终端实时监视电池电量，实现激光引导机
器人低电量下自主充电，电量充满后继续巡检工作。</div>
          </div> 
        </div>
      </div>
    </div>
    <div class="more_down">
      <div class="title_wrap">
        <div class="title">
          相关下载
        </div>
        <div class="mini_title">
          DOWNLOAD
        </div>
      </div>
      <div>
        <img src="../assets/code.png" alt="">
      </div>
    </div>
    <v-foot class="more_foot"></v-foot>
  </div>
</template>
<script>
import router from '../router/index.js'
export default {
  methods: {
    gotoHome() {
      router.push('/')
    },
    gotoDetail() {
      router.push('/detail10')
    }
  },
}
</script>
<style scoped>

.head {
  position: absolute;
  background-color: #000;
  height: 75px;
  top: 0;
  width: 100%;
}
.head img {
  margin-top: 10px;
  width: 55px;
  height: 57px;
  margin-left: 20px;
}
.more_bg img {
  margin-top: 75px;
  width: 100%;  
  height: 600px;  
}
.more_txt {
  position: absolute;
  top: 260px;
  right: 420px;
  color: #fff ;
}
.more_txt .title {
  font-size: 58px;
}
.more_txt .txt {
  margin-top: 32px;
  font-size: 32px;
}
.more_text {
  display: flex;
}

.more_content {
  display: flex;
  margin-top: 30px;
  justify-content: center;
  width: 70%;
  align-items: center;
  margin: 0 auto;
  padding-top: 80px;
}
.more_left img{
  width: 420px;
  height: 360px;
}
.more_right {
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-left: 50px;
}
.more_right img {
  width: 210px;
  height: 120px;
}
.more_right .maxTitle {
  font-size: 28px;
  color: #333;
  font-weight: 600;
}
.more_right .title {
  margin: 15px 0;
  font-size: 22px;
  color: #333;
  font-weight: 600;
}
.more_right .txt {
  font-size: 15px;
  color: #333;
}
.more_wrap {
  width: 620px;
  border-top: 1px solid #333;
  margin: 15px 0;
}
.more_wrap .last {
  margin-top: 10px;
}
.more_detail {
  width: 1000px;
  margin: 0 auto;
}
.more_detail .title {
  color: #333;
  font-size: 26px;
  font-weight: 600;
}
.more_detail .mini_title {
  font-size: 18px;
  color: #ccc;
  margin-top: 10px;
}
.more_detail .title_wrap {
  border-bottom: 1px solid #ccc;
  padding-bottom: 20px;
  margin-bottom: 45px;
}
.more_detail .more_top {
  display: flex;
}
.more_top .more_list {
  border: 1px solid #dee;
  box-shadow: 1px 1px 1px 1px #eee;
  margin-right: 50px;
  width: 300px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 20px 10px;

}
.end .more_list {
  width: 280px;
  padding: 20px 10px;
  margin-top: 50px;
}
.more_detail .bottom {
  margin-right: 0;
}
.more_detail .begin {
  margin-bottom: 50px;
}
.more_detail .more_list .title {
  font-size: 18px;
  font-weight: 600;
}
.more_detail .more_list .en {
  font-size: 14px;
  padding: 10px 0;
  color: #bbb;
}
.more_detail .more_list .txt {
  font-size: 14px;
  color: #333;
  display: flex;
}
.el-icon-caret-right {
  margin-top: 5px;
  color: #333;
}
.more_detail .more_bottom {
  border: 1px solid #dee;
  box-shadow: 1px 1px 1px 1px #eee;
  margin-right: 50px;
  width: 280px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-top: 30px;
  padding: 30px 10px;


}
.more_down {
  width: 1000px;
  margin: 0 auto;
}
.more_down .title {
  color: #333;
  font-size: 26px;
  font-weight: 600;
  margin-top: 60px;
}
.more_down .mini_title {
  font-size: 18px;
  color: #ccc;
  margin-top: 10px;
}
.more_down .title_wrap {
  border-bottom: 1px solid #ccc;
  padding-bottom: 20px;
  margin-bottom: 45px;
}
.more_foot {
  margin-top: 50px;
}

</style>


// WEBPACK FOOTER //
// src/components/MoreInfor9.vue